<template>
  <div class='step2' style=''>
    <a-form-model ref='form' :model='model' :rules='validatorRules'>
      <a-form-model-item  prop='elementSource'>
        <a-card size='small' hoverable>
          <div class='header'><b>元素数据源</b><a-button @click='addDataSource("element")' type="primary" size='small' style='float: right'>添加</a-button></div>
          <a-divider style='margin: 12px 0'/>
          <div class='list' v-if="model.itemList1">
            <div class='list-item' v-for='(item,index) in model.itemList1'>
              <a-space :size='12'>
                <span>数据源{{index + 1}}</span>
                <a-select v-model='item.formId' placeholder='请选择表单' style='width: 200px' showSearch @change="source1Change(item,null)" :filterOption="filterOptionTip">
                  <a-select-option :value='form.id' v-for="form in form1List" :key="form.id">
                    <a-tooltip :title="form.description" placement="right">
                      {{form.name}}
                    </a-tooltip>
                  </a-select-option>
                </a-select>
                <a-select v-model='item.sourceId' placeholder='请选择元素' style='width: 500px' showSearch @change="source1ItemChange(item)"  :filterOption="filterOption">
                  <a-select-option :value='formItem.id' v-for="formItem in item.formItemList" :key="formItem.id">{{formItem.number || ""}}{{formItem.name}}</a-select-option>
                </a-select>
                <span>
                  <a-icon type="setting" theme="twoTone"
                              v-if="item.mappingList && item.mappingList.length>0"
                          @click='optionMappingSetting(item)' title='选项映射关系配置'/>
                </span>
                <span><a-icon type="close" @click='removeDataSource("element", index)'/></span>
                <span v-if="item.isCheckValue">多选题：              
                  <a-radio-group v-model="item.checkValueType">
                    <a-radio value="1">选项值求和</a-radio>
                    <a-radio value="2">保留原值</a-radio>
                  </a-radio-group>
                </span>
              </a-space>
            </div>
          </div>
        </a-card>
      </a-form-model-item>
      <a-form-model-item  prop='elementSource'>
        <a-card size='small' hoverable>
          <div class='header'><b>基本信息数据源</b><a-button @click='addDataSource("baseInfo")' type="primary" size='small' style='float: right'>添加</a-button></div>
          <a-divider style='margin: 12px 0'/>
          <div class='list' v-if="model.itemList2">
            <div class='list-item' v-for='(item,index) in model.itemList2'>
              <a-space :size='12'>
                <span>数据源{{ index + 1}}</span>
                <a-select v-model='item.sourceId' placeholder='请选择基础信息' style='width: 300px' showSearch @change="source2Change(item)" :filterOption="filterOption">
                  <a-select-option :value='field.id' v-for="field in patientFieldList" :key="field.id">{{field.name}}</a-select-option>
                </a-select>
                <span><a-icon type="close" @click='removeDataSource("baseInfo", index)'/></span>
              </a-space>
            </div>
          </div>
        </a-card>
      </a-form-model-item>
      <a-form-model-item  prop='elementSource'>
        <a-card size='small' hoverable>
          <div class='header'><b>量表数据源</b><a-button @click='addDataSource("scale")' type="primary" size='small' style='float: right'>添加</a-button></div>
          <a-divider style='margin: 12px 0'/>
          <div class='list' v-if="model.itemList3">
            <div class='list-item' v-for='(item,index) in model.itemList3'>
              <a-space :size='12'>
                <span>数据源{{index + 1}}</span>
                <a-select v-model='item.formId' placeholder='请选择表单' style='width: 300px' showSearch @change="source3Change(item,null)" :filterOption="filterOption">
                  <a-select-option :value='form.id' v-for="form in form2List" :key="form.id">{{form.name}}</a-select-option>
                </a-select>
                <a-select v-model='item.sourceId' placeholder='请选择元素' style='width: 600px' showSearch @change="source3ItemChange(item)" :filterOption="filterOption">
                  <a-select-option :value='formItem.id' v-for="formItem in item.formItemList" :key="formItem.id">{{formItem.number || ""}}{{formItem.name}}</a-select-option>
                </a-select>
                <span><a-icon type="close" @click='removeDataSource("scale", index)'/></span>
              </a-space>
            </div>
          </div>
        </a-card>
      </a-form-model-item>
      <a-form-model-item  prop='elementSource'>
        <a-card size='small' hoverable>
          <div class='header'><b>周期数据源</b><a-button @click='addDataSource("period")' type="primary" size='small' style='float: right'>添加</a-button></div>
          <a-divider style='margin: 12px 0'/>
          <div class='list' v-if="model.itemList4">
            <div class='list-item' v-for='(item,index) in model.itemList4'>
              <a-space :size='12'>
                <span>数据源{{index + 1}}</span>
                <!-- <a-select v-model='item.formId' placeholder='请选择周期' style='width: 300px' showSearch :filterOption="filterOption">
                  <a-select-option :value='period.id' v-for="period in periodList" :key="period.id">{{period.name}}</a-select-option>
                </a-select> -->
                <a-select v-model='item.sourceId' placeholder='请选择元素' style='width: 600px' showSearch @change="source4ItemChange(item)" :filterOption="filterOption">
                  <a-select-option :value='periodItem.value' v-for="periodItem in periodItemList" :key="periodItem.value">{{periodItem.label}}</a-select-option>
                </a-select>
                <span><a-icon type="close" @click='removeDataSource("period", index)'/></span>
              </a-space>
            </div>
          </div>
        </a-card>
      </a-form-model-item>
    </a-form-model>
    <!--选项映射关系配置-->
    <option-mapping-setting ref='OptionMappingSetting' @ok='mappingListOk'></option-mapping-setting>
  </div>
</template>

<script>
import OptionMappingSetting from '@views/project/setting/formula/OptionMappingSetting'
import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
import { getAction,postAction } from '@/api/manage'
import Vue from 'vue'

export default {
  name: 'Step2',
  components: {  OptionMappingSetting },
  data() {
    return {
      model:{
      },
      projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
      validatorRules: {},
      form1List:[],
      form2List:[],
      patientFieldList:[],
      // periodList:[],
      periodItemList:[{ label: '周期开始时间', value: 'startDate' },{ label: '周期结束时间', value: 'endDate' }, { label: '周期完成时间', value: 'submitDate' },{ label: '周期分组名称', value: 'groupName' }],
    }
  },
  created() {

  },
  methods: {
    view(model){
      this.model = JSON.parse(JSON.stringify(model))

      Promise.all([
        getAction('/project/projectForm/listAll',{projectId:this.projectId}),
        getAction('/project/projectPatientField/editList',{projectId:this.projectId}),
        getAction('/project/projectForm/listAll',{projectId:this.projectId,type:'2'}),
        // getAction('/project/projectPeriodItem/list',{projectId:this.model.projectId,halfway:'0'}),
      ]).then(([res1,res2,res3,res4])=>{
        if(res1.success){
          this.form1List=res1.result
        }
        if(res2.success){
          this.patientFieldList=res2.result
        }
        if(res3.success){
          this.form2List=res3.result
        }
        // if(res4.success){
        //   this.periodList=res4.result
        // }      
        this.loadExistData()
      })
    },
    loadExistData(){
      if(this.model.id){
        getAction('/project/projectFormulaItem/list',{formulaId:this.model.id}).then(res=>{
          if(res.success){
            const itemList1 = []
            const itemList2 = []
            const itemList3 = []
            const itemList4 = []
            res.result.forEach(item=>{
              if(item.sourceType==='1'){
                itemList1.push(item);
                this.source1Change(item,(formItemList)=>{
                  formItemList.forEach(item2=>{
                    if(item.sourceId===item2.id){
                      this.source1ItemChange(item)                      
                    }                    
                  })
                })

              }
              if(item.sourceType==='3'){
                itemList2.push(item);
                this.source2Change(item)
              }
              if(item.sourceType==='2'){
                itemList3.push(item);
                this.source3Change(item,(formItemList)=>{
                  formItemList.forEach(item2=>{
                    if(item.sourceId===item2.id){
                      this.source3ItemChange(item)
                    }
                  })
                })
              }
              if(item.sourceType==='5'){//周期数据源
                itemList4.push(item);
                this.source4ItemChange(item)
              }
            })
            this.$set(this.model,'itemList1',itemList1)
            this.$set(this.model,'itemList2',itemList2)
            this.$set(this.model,'itemList3',itemList3)
            this.$set(this.model,'itemList4',itemList4)
          }
        })
      }
    },
    source1ItemChange(item){
      if(item.sourceId){
        let formItem = item.formItemList.filter(formItem=> formItem.id===item.sourceId)[0]
        item.name=`【${item.formName}.${formItem.number?formItem.number:''}.${formItem.name}】`
        getAction('/project/projectFormItem/queryById',{id:item.sourceId}).then(res=>{
          if(res.success){
            const formItem = res.result

            this.$set(item,'formItem',formItem)
            let mappingList = []
            if( formItem.element && formItem.element.dictItemList && formItem.element.dictItemList.length){
              mappingList = JSON.parse(JSON.stringify(formItem.element.dictItemList))
            }
            if(item.mappingList ){
              mappingList.forEach(mapping =>{
                item.mappingList.forEach(itemMapping=>{
                  if(mapping.value===itemMapping.dictValue){
                    mapping.mappingValue = itemMapping.mappingValue
                  }
                })
              })
            }
            this.$set(item,'mappingList',mappingList)
            // console.log(item.mappingList,'item.mappingList')
          }
        })
        let items = item.formItemList.filter(i=>i.id == item.sourceId)
        if(items && items.length > 0){
          if(items[0].elementType=='check'){
            this.$set(item,'isCheckValue',true)
            if(!item.checkValueType){
              this.$set(item,'checkValueType',"1")
            }else{
              this.$set(item,'checkValueType',item.checkValueType+'')
            }
          }else{
            this.$set(item,'isCheckValue',false)
          }
        }        
      }
      else{
        this.$set(item,'mappingList',[])
      }
    },
    source1Change(item,itemCallBack){
      if(item.sourceId && !itemCallBack){
        item.sourceId = ''
        item.formItem = null
        this.$set(item,'formItemList',[])
      }
      if(item.formId){
        item.formName=this.form1List.filter(form=> form.id===item.formId)[0].name
        getAction('/project/projectFormItem/listAll',{formId:item.formId,scale:'0'}).then(res=>{
          if(res.success){
            this.$set(item,'formItemList',res.result)
            if(itemCallBack){
              itemCallBack(item.formItemList)
            }
          }
        })
      }
    },
    source2Change(item){
      const field = this.patientFieldList.filter(field=>field.id===item.sourceId)[0]
      if(field){
        item.name=`[${field.name}]`
      }
    },
    source4ItemChange(item){
      const field = this.periodItemList.filter(field=>field.value===item.sourceId)[0]
      if(field){
        item.name=`【${field.label}】`
      }
    },
    source3ItemChange(item){
      if(item.sourceId){
        item.name=`【${item.formName}.${item.formItemList.filter(formItem=> formItem.id===item.sourceId)[0].name}】`
      }
    },
    source3Change(item,itemCallBack){
      if(item.sourceId && !itemCallBack){
        item.sourceId = ''
        this.$set(item,'formItemList',[])
      }
      if(item.formId){
        item.formName=this.form2List.filter(form=> form.id===item.formId)[0].name
        getAction('/project/projectFormItem/listAll',{formId:item.formId,scale:'1'}).then(res=>{
          if(res.success){
            this.$set(item,'formItemList',res.result)
            if(itemCallBack){
              itemCallBack(item.formItemList)
            }
          }
        })
      }
    },
    /**
     * 添加数据源
     * @param key
     */
    addDataSource(key) {
      switch (key) {
        case 'element':
          const dataSource1 = this.model.itemList1 || []
          let item
          if(dataSource1.length===0){
            item = {sourceType: '1'}
          }else{
            item = JSON.parse(JSON.stringify(dataSource1[dataSource1.length-1]))
          }
          dataSource1.push(item)
          this.$set(this.model,'itemList1',dataSource1)
          break
        case 'baseInfo':
          const dataSource2 = this.model.itemList2 || []
          dataSource2.push({sourceType: '3'})
          this.$set(this.model,'itemList2',dataSource2)
          break
        case 'scale':
          const dataSource3 = this.model.itemList3 || []
          dataSource3.push({sourceType: '2'})
          this.$set(this.model,'itemList3',dataSource3)
          break
        case 'period':
          const dataSource4 = this.model.itemList4 || []
          dataSource4.push({sourceType: '5'})
          this.$set(this.model,'itemList4',dataSource4)
          break
      }
    },
    /**
     * 移除数据源
     * @param key
     * @param index
     */
    removeDataSource(key, index) {
      // console.log("key:"+ key)
      switch (key) {
        case 'element':
          this.model.itemList1.splice(index, 1)
          break
        case 'baseInfo':
          this.model.itemList2.splice(index, 1)
          break
        case 'scale':
          this.model.itemList3.splice(index, 1)
          break
        case 'period':
          this.model.itemList4.splice(index, 1)
          break
      }
    },
    /**
     * 选项映射关系配置
     */
    optionMappingSetting(item) {
      const findElementObj = [].find(item => item.name === element) || {}
      if (!findElementObj.dictCode) {
        // this.$message.warning('数据源不是选择题')
        // return
      }
      this.$refs['OptionMappingSetting'].view(item)
    },
    mappingListOk(item,mappingList){
      this.$set(item,'mappingList',mappingList)
    },

    validate() {
      let result = true
      if( !(
        (this.model.itemList1 && this.model.itemList1.length>0)
        ||(this.model.itemList2 && this.model.itemList2.length>0)
        ||(this.model.itemList3 && this.model.itemList3.length>0)
        ||(this.model.itemList4 && this.model.itemList4.length>0)
      )){
        result = false
        this.$message.warning('数据源不能为空')
      }
      if(this.model.itemList1 && result){
        const nameList = []
        this.model.itemList1.forEach((item,index)=>{
          if(!result){
            return
          }
          if(!item.sourceId ){
            result = false
            this.$message.warning(`元素数据源${index+1}请填写完整`)
          }
          // if(nameList.indexOf(item.name)>=0){
          //   result = false
          //   this.$message.warning(`元素数据源${index+1}重复添加`)
          //   return
          // }else{
          //   nameList.push(item.name)
          // }
        })
      }
      if(this.model.itemList2 && result){
        const nameList = []
        this.model.itemList2.forEach((item,index)=>{
          if(!result){
            return
          }

          if(!item.sourceId){
            result = false
            this.$message.warning(`基本信息数据源${index+1}请填写完整`)
            return
          }
          if(nameList.indexOf(item.name)>=0){
            result = false
            this.$message.warning(`基本信息数据源${index+1}重复添加`)
            return
          }else{
            nameList.push(item.name)
          }
        })
      }
      if(this.model.itemList3 && result){
        const nameList = []
        this.model.itemList3.forEach((item,index)=>{
          if(!result){
            return
          }
          if(!item.sourceId ){
            result = false
            this.$message.warning(`量表数据源${index+1}请填写完整`)
            return
          }
          // if(nameList.indexOf(item.name)>=0){
          //   result = false
          //   this.$message.warning(`量表数据源${index+1}重复添加`)
          //   return
          // }else{
          //   nameList.push(item.name)
          // }
        })
      }
      if(this.model.itemList4 && result){
        const nameList = []
        this.model.itemList4.forEach((item,index)=>{
          if(!result){
            return
          }

          if(!item.sourceId){
            result = false
            this.$message.warning(`周期数据源${index+1}请填写完整`)
            return
          }
          if(nameList.indexOf(item.name)>=0){
            result = false
            this.$message.warning(`周期数据源${index+1}重复添加`)
            return
          }else{
            nameList.push(item.name)
          }
        })
      }
      return result
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filterOptionTip(input, option) {
      return option.componentOptions.children[0].componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }

}
</script>

<style scoped>
.step2 {
  padding: 0 80px;
}
.header {
  font-size: 16px;
}
.list > .list-item {
  margin: 12px auto;
  width: 1200px;
}
</style>
